import React, { useEffect, useState } from "react";
import { Modal, ModalBody, ModalHeader, Table, Button } from "reactstrap";
import PurchaseService from "../../../services/OrderingServices/PurchaseService";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

const PurchaseBill = ({
  isOpen,
  toggle,
  selectedPurchase,
  onPaymentDone,
  fetchPurchase,
}) => {
  const [purchaseData, setPurchaseData] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (selectedPurchase?.id) {
      fetchPurchaseDetail(selectedPurchase.id);
    }
  }, [selectedPurchase]);

  const fetchPurchaseDetail = async (id) => {
    try {
      const response = await PurchaseService.detail(id);
      setPurchaseData(response);
    } catch (error) {
      console.error("Error fetching purchase detail:", error);
    }
  };

  const handlePay = async () => {
    try {
      const res = await PurchaseService.markBillPaid(purchaseData.id);

      toast.success("Payment done successfully!");

      // Update local state immediately
      setPurchaseData((prev) => ({
        ...prev,
        paymentStatus: "Paid",
      }));

      // Notify parent to update table/list
      onPaymentDone && onPaymentDone(purchaseData.id);

      toggle(); // Close modal
      fetchPurchase();
    } catch (error) {
      console.error(error);
      toast.error(error.response?.data?.message || "Payment failed!");
    }
  };

  if (!purchaseData) return null;

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="md">
      <ModalHeader toggle={toggle}>
        Purchase Details - {purchaseData.supplierName}
      </ModalHeader>
      <ModalBody style={{ fontFamily: "monospace" }}>
        <div className="p-3">
          {/* Supplier Info */}
          <div className="text-center mb-4">
            <h5 className="fw-bold text-uppercase mb-0">
              {purchaseData.supplierName}
            </h5>
            <div>{purchaseData.supplierContact}</div>
          </div>

          {/* Purchase Info */}
          <div className="d-flex justify-content-between small mb-3">
            <div>
              <strong>Purchase Date:</strong> {purchaseData.purchaseDate_Nep}
            </div>
            <div>
              <strong>Status:</strong> {purchaseData.paymentStatus}
            </div>
          </div>

          {/* Items Table */}
          <Table size="sm" responsive className="table-bordered small mb-0">
            <thead className="table-light">
              <tr>
                <th>#</th>
                <th>Item</th>
                <th className="text-end">Unit Price</th>
                <th className="text-center">Qty</th>
                <th className="text-end">Total</th>
              </tr>
            </thead>
            <tbody>
              {purchaseData.items.map((item, index) => (
                <tr key={item.id}>
                  <td>{index + 1}</td>
                  <td>{item.productName}</td>
                  <td className="text-end">
                    {item.unitPrice.toLocaleString()}
                  </td>
                  <td className="text-center">{item.quantity}</td>
                  <td className="text-end">
                    {item.totalPrice.toLocaleString()}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>

          {/* Totals */}
          <div className="border-top pt-2 small d-flex justify-content-between fw-bold">
            <span>Total Amount</span>
            <span>{purchaseData.totalAmount.toLocaleString()}</span>
          </div>

          {/* Buttons aligned on same line */}
          <div className="mt-3 d-flex justify-content-end gap-2">
            <Button
              color="primary"
              onClick={() => navigate(`/purchase/detail/${purchaseData.id}`)}
            >
              View
            </Button>
            {/* {purchaseData.paymentStatus.toLowerCase() !== "paid" && (
              <Button color="success" onClick={handlePay}>
                Pay
              </Button>
            )} */}
          </div>

          <div className="small mt-2 text-center">**Thank You**</div>
          <div className="small text-center text-muted">
            Powered by Restro Order
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default PurchaseBill;
